export default {
  'quotations.request': 'Pedido Cotação',
};
